import React from 'react';
import { motion } from 'framer-motion';
import { FiChevronRight, FiMapPin, FiActivity } from 'react-icons/fi';

export default function SmallListStealth({ data, color }) {
    // 🛡️ BLINDAGEM DE DADOS (API Real + Mock)
    const title = data?.titulo || data?.title || 'Ativo Não Identificado';
    const price = data?.preco || data?.price;
    const location = data?.bairro || data?.location || 'Setor Privado';
    const ref = data?._id?.slice(-4).toUpperCase() || data?.id?.slice(-4) || '7702';

    const formattedPrice = typeof price === 'number' 
        ? price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        : price || 'Sob Consulta';

    return (
        <motion.div 
            whileHover={{ x: 10 }}
            className="group flex items-center gap-6 p-5 border-b transition-all duration-300 cursor-pointer"
            style={{ 
                borderColor: 'var(--border-color)',
                backgroundColor: 'transparent'
            }}
        >
            {/* 🎯 STATUS INDICATOR */}
            <div className="relative flex items-center justify-center">
                <div className="w-2.5 h-2.5 rounded-full shadow-[0_0_10px_rgba(0,0,0,0.5)] transition-transform group-hover:scale-150" 
                     style={{ backgroundColor: color || 'var(--accent-color)' }} />
                <div className="absolute w-2.5 h-2.5 rounded-full animate-ping opacity-40" 
                     style={{ backgroundColor: color || 'var(--accent-color)' }} />
            </div>

            {/* 📄 DATA CORE */}
            <div className="flex-1 grid grid-cols-12 items-center gap-4">
                
                {/* Título e Ref */}
                <div className="col-span-5 flex flex-col">
                    <div className="font-black text-auto uppercase text-[11px] tracking-widest group-hover:text-accent transition-colors truncate"
                         style={{ color: 'var(--text-primary)' }}>
                        {title}
                    </div>
                    <div className="text-[8px] font-mono opacity-20 uppercase tracking-tighter text-auto">
                        REF: {ref}
                    </div>
                </div>

                {/* Localização */}
                <div className="col-span-4 flex items-center gap-2">
                    <FiMapPin size={10} className="opacity-20 text-auto" />
                    <div className="font-mono text-auto opacity-40 text-[9px] uppercase tracking-widest truncate">
                        {location}
                    </div>
                </div>

                {/* Preço */}
                <div className="col-span-3 text-right">
                    <div className="font-black text-auto text-[11px] tracking-tighter"
                         style={{ color: 'var(--text-primary)' }}>
                        {formattedPrice}
                    </div>
                </div>
            </div>

            {/* ⚡ ACTION INDICATOR */}
            <div className="flex items-center gap-4">
                <FiActivity size={12} className="opacity-0 group-hover:opacity-20 text-auto animate-pulse" />
                <div className="w-8 h-8 rounded-full border border-auto flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-auto">
                    <FiChevronRight size={14} className="text-auto" />
                </div>
            </div>
        </motion.div>
    );
}